export default __webpack_public_path__ + "static/media/germany.1708c5f7.svg";